import type { UserQuery } from '@/generated/graphql'

type UserData = UserQuery['me']
export type ActivePlanData = UserData['availablePlans'][number]

export function activePlan(
  user: UserData | undefined,
): ActivePlanData | undefined {
  if (!user) return undefined
  return (
    user.availablePlans.find((p) => p.id === user.activePlanId) ??
    user.availablePlans[0]
  )
}
